<div *transloco="let t" class="onboarding-page-container">
  <div class="title">
    {{ t('onboarding.fifthPage.text', {allPlacesCount: loyaltyLevelAggregations().length}) }}
  </div>
  @for (loyaltyLevelAggregation of sortedLoyaltyLevels(); track loyaltyLevelAggregation) {
    <div class="pill-container" *transloco="let t">
      <lib-pill-loyalty [loyaltyScore]="averageLoyalties[loyaltyLevelAggregation.level]"
                        [loyaltyLevel]="loyaltyLevelAggregation.level"
                        [size]="Size.BIG">
      </lib-pill-loyalty>
      @if (loyaltyLevelAggregation.count === 1) {
        <span class="after-pill-text">{{ t('onboarding.fifthPage.atPlace') }}</span>
      } @else {
        <span class="after-pill-text">{{ t('onboarding.fifthPage.atPlaces', {placesCount: loyaltyLevelAggregation.count}) }}</span>
      }
    </div>

  }
  <img class="star" ngSrc="assets/images/onboarding/star-multicolored-bigger.png" priority height="281" width="188"
       alt="star">
</div>
